"use client";
import { useEffect } from "@/utils/hooks/reactUseCustomHooks";
import BreadcrumbWrapper from "@/components/Breadcrumb";
import { SiteContainer } from "@/components/Container";
import { Columns, Row, Box } from "@dxp-feed/ui";
import StoreDetailSelection from "@/templates/storeDetail/StoreDetailSelection";
import StoreInfoHours from "@/templates/storeDetail/StoreInfoHours";
import WhatsNewInStore from "@/templates/storeDetail/WhatsNewInStore";
import { useState } from "react";
import StoreUpdateDialog from "@/templates/stores/StoreUpdateDialog";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/utils/redux/store";
import { setSelectedStore, IListStores } from "@/utils/redux/storeLocator";
import { saveToLocalStorage, setStoreCookies } from "@/helpers/storageHelper";
import Loader from "@/components/Loader";
import { useUpdateStore } from "@/utils/hooks/useUpdateStore";
import { setCookie } from "cookies-next";

const StoreDetailsPage = ({ storeData }: any) => {
  const dispatch = useDispatch();
  const [store, setStore] = useState<IListStores | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [storeToConfirm, setStoreToConfirm] = useState<IListStores | null>(
    null
  );
  const selectedStore = useSelector(
    (state: RootState) => state.selectedStore.data as IListStores
  );
  const [loading, setLoading] = useState(true);
  const [confrimLoading, setConfrimLoading] = useState(false);
  const openDialog = () => setIsOpen(true);
  const closeDialog = () => setIsOpen(false);
  // Use the custom hook to get the function that updates the store
  const { updateStoreIfAuthorized } = useUpdateStore();

  useEffect(() => {
    if (storeData) {
      setStore(storeData);
      setLoading(false);
    }
  }, [storeData]);

  const handleStoreSelection = (selectedStore: IListStores): void => {
    saveToLocalStorage("store", selectedStore);
    saveToLocalStorage("storeRegion", selectedStore?.region?.[0]);
    setStoreCookies(selectedStore?.storeNumber, selectedStore?.region?.[0]);
    setCookie("province", selectedStore?.address?.province)
    dispatch(setSelectedStore(selectedStore));
  };

  //confirmation for select store
  const confirmStoreSelection = async () => {
    setConfrimLoading(true);
    if (storeToConfirm) {
      handleStoreSelection(storeToConfirm);
      await updateStoreIfAuthorized(storeToConfirm?.storeNumber);
      setConfrimLoading(false);
    }
    closeDialog();
  };

  //cancel select store
  const cancelStoreSelection = (): void => {
    setStoreToConfirm(null);
    closeDialog();
  };

  const breadcrumb = [
    { text: "Home", href: "/", ariaLabel: "Go to Home" },
    {
      text: "Store Locator",
      href: "/store-locator",
      ariaLabel: "Go to Store Locator",
    },
    {
      text: store?.locationName as string,
      href: null,
      ariaLabel: `Current page: ${store?.locationName}`,
    },
  ];

  return (
    <>
      {loading ? (
        <Box className="min-h-[500px] flex items-center justify-center">
          <Loader />
        </Box>
      ) : (
        <>
          <Box className="border-t-[1px] border-solid border-grey350">
            <SiteContainer>
              <Row>
                <Columns>
                  <BreadcrumbWrapper breadcrumbList={breadcrumb} />
                </Columns>
              </Row>
            </SiteContainer>
          </Box>
          <StoreDetailSelection
            store={store}
            selectedStore={selectedStore}
            openDialog={openDialog}
            setStoreToConfirm={setStoreToConfirm}
          />
          <SiteContainer>
            <StoreInfoHours store={store} />
            <WhatsNewInStore
              store={store}
              selectedStore={selectedStore}
              openDialog={openDialog}
              setStoreToConfirm={setStoreToConfirm}
            />
          </SiteContainer>
          <StoreUpdateDialog
            isOpen={isOpen}
            onClose={closeDialog}
            confirmStoreSelection={confirmStoreSelection}
            cancelStoreSelection={cancelStoreSelection}
            confrimLoading={confrimLoading}
          />
        </>
      )}
    </>
  );
};

export default StoreDetailsPage;
